import { Text } from '../Text';
import React from 'react';
export const createHighlighted = (fullString, currentLocation, lengthOfQueryString) => /*#__PURE__*/React.createElement(Text, {
  size: 2,
  weight: "heavy"
}, fullString.slice(currentLocation, currentLocation + lengthOfQueryString));
export const createUnhighlighted = (fullString, previousQueryStringLocation, currentQueryStringLocation) => /*#__PURE__*/React.createElement(Text, {
  size: 2
}, fullString.slice(previousQueryStringLocation, currentQueryStringLocation));
export const buildEscapedRegex = query => {
  const escapedQuery = query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  return new RegExp(escapedQuery, 'gi');
};